<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" style="max-height: 90px;" alt="logo"></a>
                    <p style="margin-top:-10px">
                        Progettiamo ed eroghiamo attività formative nell’ambito formazione aziendale, con progetti finanziati a valere su bandi regionali e nazionali e con fondi interprofessionali. Progettiamo ed eroghiamo attività di welfare a valere su bandi provenienti da istituzioni pubbliche nazionali e comunitarie
                    </p>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/cdq.formazione" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/cdqformazione/" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="https://it.linkedin.com/company/cdq-formazione" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>
                        <div class="row pt-3">
                            <div class="col-12 p-0" align="left">
                                <a href="https://apps.apple.com/it/app/discentya/id6468484981" target="_blank">
                                    <img src="assets/img/applestore-badge-white.png" style="width: 160px;">
                                    <img src="assets/img/googlestore-badge-white.png" class="ms-3" style="width: 160px;">
                                </a>
                            </div>
                        </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>LINK</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>LOGIN</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Menù</a></li>
                        <li><a href="#" target="_blank">Docenti/Tutor</a></li>
                        <li><a href="#" target="_blank">Partner</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>DOVE SIAMO</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Via Alcide De Gasperi, 178<br>76012 Canosa di Puglia</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+393440688154">Telefono: (+39) 344-0688154</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:amministrazione@cdqformazione.it">amministrazione@cdqformazione.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+393440688154">Lunedì-Venerdì<br>09:00 ÷ 18:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2025 CDQ Formazione  - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
